import { Component, computed, input, ChangeDetectionStrategy } from '@angular/core';
import { OuiTagModule } from 'omnium-ui/tag';
import { normalizeValue } from '../common.utils';

export type TagStatus = 'completed' | 'in-progress' | 'todo' | 'error' | 'to-correct' | 'transition' | 'pending';

@Component({
  selector: 'dbw-investor-status-tag',
  imports: [OuiTagModule],
  changeDetection: ChangeDetectionStrategy.Eager,
  template: `
    <oui-tag
      type="status"
      size="big"
      [status]="tagStatus()">
      {{ label() }}
    </oui-tag>
  `,
})
export class InvestorStatusTagComponent {
  readonly statusCode = input<string | null | undefined>(undefined);

  protected readonly label = computed(() => {
    const value = this.statusCode()?.trim();
    return value ? value : 'NR';
  });

  protected readonly tagStatus = computed<TagStatus>(() => {
    const normalized = normalizeValue(this.statusCode());

    switch (normalized) {
      case 'CLIENT':
        return 'completed';
      case 'PROSPECT':
        return 'transition';
      case 'CONTACT':
        return 'pending';
      case 'SUPPRIME':
        return 'error';
      default:
        return 'pending';
    }
  });
}
